export default class ShowContentHelper {
    constructor() {
        let small_screen = 600;
        let medium_screen = 1024;
        let show_on_large = 1700;
        
        let width = window.innerWidth;

        this.hide 	                 = false;
        this.hide_on_small_only 	 = width > small_screen;
        this.hide_on_med_only 	     = width <= small_screen || width > medium_screen;
        this.hide_on_med_and_down 	 = width > medium_screen;
        this.hide_on_med_and_up 	 = width <= small_screen;
        this.hide_on_large_only 	 = width <= medium_screen;
        this.show_on_small 	         = width <= small_screen;
        this.show_on_medium 	     = width > small_screen && width <= medium_screen;
        this.show_on_medium_and_up 	 = width > small_screen;
        this.show_on_medium_and_down = width <= medium_screen;	
        this.show_on_large 	         = width > medium_screen && width <= show_on_large;
        this.show_on_large_and_up 	 = width > show_on_large;
    }
}


// WEBPACK FOOTER //
// ./src/components/helpers/ShowContentHelper.js